import dlt from '../translations/sk.json';

export default dlt;
